import React from "react";
import Login from "../pages/auth/login";
import ForgotPassword from "../pages/auth/forgot-password";
import ResetPassword from "../pages/auth/reset-password";
import AcceptInvitation from "../pages/auth/accept-invitation";
import Page from "@jumbo/shared/Page";

const authRoutes = [
    {
        path: "/auth/login",
        element: <Page component={Login} layout="solo-page" />,
    },
    // {
    //     path: "/auth/signup",
    //     element: <Page component={Signup} layout="solo-page" />
    // },
    {
        path: "/auth/forgot-password",
        element: <Page component={ForgotPassword} layout="solo-page" />
    },
    {
        path: "/auth/reset-password",
        element: <Page component={ResetPassword} layout="solo-page" />
    },
    {
        path: "/auth/accept-invitation",
        element: <Page component={AcceptInvitation} layout="solo-page" />
    }
];

export default authRoutes;
